export const blockIconsPrivacyandsecurityShieldPersonNew = (
	<span className='material-symbols-outlined'>shield_person</span>
);
